import React from "react";
import { PaymentTable } from "../Tables";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl";
import { toast } from "react-hot-toast";
import { transactionData } from "../Datas";

function PaymentsUsed({ doctor, patientId }) {
  const navigate = useNavigate();
  const [payments, setPayments] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  // Fetch payments for patient
  React.useEffect(() => {
    const fetchPayments = async () => {
      if (!patientId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(
          `${BaseUrl}/doctor/patient/payments/${patientId}`,
          {
            withCredentials: true,
          }
        );

        if (Array.isArray(response.data)) {
          setPayments(response.data);
        } else if (response.data?.data && Array.isArray(response.data.data)) {
          setPayments(response.data.data);
        } else {
          setPayments([]);
        }
      } catch (error) {
        console.error("Error fetching payments:", error);
        // Don't show error if it's just no payments found
        if (error.response?.status !== 404) {
          toast.error(error.response?.data?.message || "Failed to load payments");
        }
        setPayments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, [patientId]);

  // onClick event handler
  const handleEventClick = (id) => {
    navigate(`/payments/preview/${id}`);
  };

  return (
    <div className='w-full'>
      <h1 className='mb-6 text-sm font-medium'>Payments</h1>
      {loading ? (
        <div className='flex items-center justify-center py-10'>
          <p className='text-textGray'>Loading payments...</p>
        </div>
      ) : (
        <div className='w-full overflow-x-scroll'>
          <PaymentTable
            data={payments.length > 0 ? payments : transactionData}
            doctor={doctor}
            functions={{
              preview: handleEventClick,
            }}
          />
        </div>
      )}
    </div>
  );
}

export default PaymentsUsed;
